import { api } from "./users";

export const getNovaPoshtaCities = async (searchText, page = "1") => {
  const res = await api.get("/novaposhta/cities/", {
    params: { q: searchText, page: String(page) },
  });
  return res.data;
};

export const getWarehousesByCity = async (cityName, search = "", page = 1) => {
  const res = await api.get("/novaposhta/warehouses/", {
    params: {
      city: cityName,
      q: search,
      page,
    },
  });
  return res.data;
};
